const getPortalApiUrl = () => {
  if (
    process.env.NODE_ENV === "production" &&
    process.env.REACT_APP_TARGET === "production"
  ) {
    return "https://portalapi.burningman.org/api";
  } else if (
    process.env.NODE_ENV === "production" &&
    process.env.REACT_APP_TARGET === "staging"
  ) {
    return "https://portalapi-staging.burningman.org/api";
  } else if (
    process.env.NODE_ENV === "production" &&
    process.env.REACT_APP_TARGET === "remotedev"
  ) {
    return process.env.REACT_APP_DEV_API_URL;
  } else if (
    process.env.NODE_ENV === "production" &&
    process.env.REACT_APP_TARGET === "loadtest"
  ) {
    return "https://portalapi-loadtest.burningman.org/api";
  } else if (
    process.env.NODE_ENV === "production" &&
    process.env.REACT_APP_TARGET === "dev"
  ) {
    return process.env.REACT_APP_DEV_API_URL;
  } else if (process.env.NODE_ENV === "development") {
    return process.env.REACT_APP_DEV_API_URL;
  } else if (process.env.NODE_ENV === "test") {
    return "https://12.34.56.78/api";
  }
};
const getProfilesAdminUrl = () => {
  if (
    process.env.NODE_ENV === "production" &&
    process.env.REACT_APP_TARGET === "production"
  ) {
    return "https://profilesadmin.burningman.org";
  } else if (
    process.env.NODE_ENV === "production" &&
    process.env.REACT_APP_TARGET === "staging"
  ) {
    return "https://profilesadmin-staging.burningman.org";
  } else if (
    process.env.NODE_ENV === "production" &&
    process.env.REACT_APP_TARGET === "remotedev"
  ) {
    return process.env.REACT_APP_DEV_PROFILESADMIN_URL;
  } else if (
    process.env.NODE_ENV === "production" &&
    process.env.REACT_APP_TARGET === "loadtest"
  ) {
    return "https://profilesadmin-loadtest.burningman.org";
  } else if (
    process.env.NODE_ENV === "production" &&
    process.env.REACT_APP_TARGET === "dev"
  ) {
    return process.env.REACT_APP_DEV_PROFILESADMIN_URL;
  } else if (process.env.NODE_ENV === "development") {
    return process.env.REACT_APP_DEV_PROFILESADMIN_URL;
  }
};

const getAuthUrl = () => {
  if (
    process.env.NODE_ENV === "production" &&
    process.env.REACT_APP_TARGET === "production"
  ) {
    return "https://login.burningman.org/oauth2/default/v1/userinfo";
  } else if (
    process.env.NODE_ENV === "production" &&
    process.env.REACT_APP_TARGET === "staging"
  ) {
    return "https://manicorn.burningman.org/oauth2/default/v1/userinfo";
  } else if (
    process.env.NODE_ENV === "production" &&
    process.env.REACT_APP_TARGET === "remotedev"
  ) {
    return "https://manicorn.burningman.org/oauth2/default/v1/userinfo";
  } else if (
    process.env.NODE_ENV === "production" &&
    process.env.REACT_APP_TARGET === "loadtest"
  ) {
    return "https://manicorn.burningman.org/oauth2/default/v1/userinfo";
  } else if (
    process.env.NODE_ENV === "production" &&
    process.env.REACT_APP_TARGET === "dev"
  ) {
    return "https://manicorn.burningman.org/oauth2/default/v1/userinfo";
  } else if (process.env.NODE_ENV === "development") {
    return "https://manicorn.burningman.org/oauth2/default/v1/userinfo";
  } else if (process.env.NODE_ENV === "test") {
    return "https://fakeserver.com/oauth2/default/v1/userinfo";
  }
};

const getVolhubApiUrl = () => {
  if (
    process.env.NODE_ENV === "production" &&
    process.env.REACT_APP_TARGET === "production"
  ) {
    return "https://volunteer.burningman.org/api";
  } else if (
    process.env.NODE_ENV === "production" &&
    process.env.REACT_APP_TARGET === "staging"
  ) {
    return "https://volunteer-staging.burningman.org/api";
  } else if (
    process.env.NODE_ENV === "production" &&
    process.env.REACT_APP_TARGET === "remotedev"
  ) {
    return process.env.REACT_APP_DEV_VOLHUB_API_URL;
  } else if (
    process.env.NODE_ENV === "production" &&
    process.env.REACT_APP_TARGET === "loadtest"
  ) {
    return "https://volunteer-staging.burningman.org/api";
  } else if (
    process.env.NODE_ENV === "production" &&
    process.env.REACT_APP_TARGET === "dev"
  ) {
    return process.env.REACT_APP_DEV_VOLHUB_API_URL;
  } else if (process.env.NODE_ENV === "development") {
    return process.env.REACT_APP_DEV_VOLHUB_API_URL;
  }
};

const getPostmanMockUrl = () => {
  return process.env.REACT_APP_PORTALAPI_URL_TEST;
};
function getFeatureFlags() {
  const featureFlags = {
    formsEnabled:
      process.env.NODE_ENV === "test"
        ? true
        : !!+process.env.REACT_APP_FORMS_ENABLED,
    vpEnabled:
      process.env.NODE_ENV === "test"
        ? true
        : !!+process.env.REACT_APP_VP_ENABLED,
    avEnabled:
      process.env.NODE_ENV === "test"
        ? true
        : !!+process.env.REACT_APP_AV_ENABLED,
    cacheEnabled:
      process.env.NODE_ENV === "test"
        ? true
        : !!+process.env.REACT_APP_CACHE_ENABLED,

    recaptchaEnabled:
      process.env.NODE_ENV === "test"
        ? false
        : !!+process.env.REACT_APP_RECAPTCHA_ENABLED,

    turnstileEnabled:
      process.env.NODE_ENV === "test"
        ? false
        : !!+process.env.REACT_APP_TURNSTILE_ENABLED,

    mockTest:
      process.env.NODE_ENV === "test"
        ? false
        : !!+process.env.REACT_APP_MOCK_TEST,
    runTest: process.env.CI ? false : true,
  };
  return featureFlags;
}

export {
  getPortalApiUrl,
  getProfilesAdminUrl,
  getAuthUrl,
  getVolhubApiUrl,
  getFeatureFlags,
  getPostmanMockUrl,
};
